// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 240;
export const MINI_DRAWER_WIDTH = 60;

// API
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5100';

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
